import type { AxiosError } from 'axios';

type RoleErrorDict = {
  generic: string;
  roleNameAlreadyExists: string;
  invalidRoleName: string;
  cannotModifySystemRole: string;
  cannotDeleteSystemRole: string;
  roleInUse: string;
  permissionEscalation: string;
  forbiddenPermissions: string;
  invalidPermissions: string;
  entitlementRequired: string;
};

export function mapRoleApiError(error: unknown, dict: RoleErrorDict): string {
  const axiosError = error as AxiosError<{
    errors?: Record<string, string | number>;
    message?: string | { code?: string };
    code?: string;
  }>;

  const status = axiosError.response?.status;
  const data = axiosError.response?.data;
  const errors = data?.errors;
  const messageBody =
    typeof data?.message === 'object' && data.message !== null
      ? data.message
      : data;
  const errorCode =
    typeof messageBody === 'object' && messageBody !== null
      ? (messageBody as { code?: string }).code
      : undefined;

  if (status === 403) {
    if (
      errorCode === 'entitlement_feature_locked' ||
      errorCode === 'entitlement_quota_exceeded'
    ) {
      return dict.entitlementRequired;
    }
    return dict.generic;
  }

  if (errors) {
    if (errors.name === 'roleNameAlreadyExists') {
      return dict.roleNameAlreadyExists;
    }
    if (errors.name === 'invalidRoleName') {
      return dict.invalidRoleName;
    }
    if (errors.role === 'cannotModifySystemRole') {
      return dict.cannotModifySystemRole;
    }
    if (errors.role === 'cannotDeleteSystemRole') {
      return dict.cannotDeleteSystemRole;
    }
    if (errors.role === 'roleInUse') {
      const count = errors.memberCount;
      if (typeof count === 'number') {
        return dict.roleInUse.replace('{count}', String(count));
      }
      return dict.roleInUse.replace('{count}', '?');
    }
    if (errors.permissions === 'permissionEscalation') {
      return dict.permissionEscalation;
    }
    if (errors.permissions === 'forbiddenPermissions') {
      return dict.forbiddenPermissions;
    }
    if (errors.permissions === 'invalidPermissions') {
      return dict.invalidPermissions;
    }
  }

  return dict.generic;
}
